// extracted by mini-css-extract-plugin
module.exports = {"header__subtext":"styles_header__subtext__OwB0Y"};